<template>
  <div class="container">
    <img
      v-if="hideIcon"
      src="@/assets/img/1x/communication-and-multimedia-sms.png"
      alt="Icono celular y mensaje"
    />
    <span class="disable-selection">{{ label }}</span>
  </div>
</template>

<script>
export default {
  name: "CustomSendSmsLink",
  props: {
    label: String,
    hideIcon: {
      type: Boolean,
      default: false
    }
  }
};
</script>

<style scoped>
span {
  font-family: BentonSansBBVA-Medium, Helvetica, Arial, sans-serif;
  font-size: 15px;
  font-weight: 500;
  line-height: 1.6;
  letter-spacing: normal;
  text-align: left;
  color: #1973b8;
  text-decoration: none;
  cursor: pointer;
}
img {
  padding-right: 2%;
}
</style>
